import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { DataQualityErrorMessage } from '../models/message-checker.model';
import { MessageCheckerEndpoint } from '../constants/message-checker-endpoint';

@Injectable({
  providedIn: 'root',
})
export class Sc3MessageCheckerService {
  constructor(private http: WrapperHttpService) {}

  checkSc3Message(payload: string): Observable<DataQualityErrorMessage> {
    const url = `${API_URL}${MessageCheckerEndpoint.Base}${MessageCheckerEndpoint.IFTSTA}${MessageCheckerEndpoint.SC3}${MessageCheckerEndpoint.Validate}`;
    return this.http.withLoading().post<DataQualityErrorMessage>(url, payload);
  }
}
